export const MenuRoutes = [
    {
        title:'Home',
        path:'/'
    }, {
        title:'Rock RWA Market(ERC721)',
        path:'/collectionsv2'
    }, 
    {
        title:'Ecosystem',
        path:'/ecosystem',
        elements:[
            // {title:'ZenoPASS',path:'/membershipspagev2'}, 
            // zenogiving.com
            // zenoreading.com
            // zenoticket.com
            // nftvideo.com
            // rwahubs.com
            {title:'Sands RWA Market(ERC1155)',path:'https://sands.rwahubs.com/#/collectionsv2', outLink:true},
            // {title:'ZenoBundle (ERC1155)',path:'https://www.zenobundle.com/#/collectionsv2', outLink:true},
            // {title:'ZenoGiving',path:'/comming'},
            // {title:'ZenoReading',path:'/comming'},
            // {title:'ZenoTicket',path:'/comming'},
            // {title:'NFTVideo',path:'/comming'}, 
            {title:'More...',path:'/comming'} 
        ]
    }, 
    {
        title:'Studio',
        path:'/studio',
        elements:[ 
            {title:'My Team Wallets',path:'/mywhitelistspagev2'},
            {title:'Create Collection',path:'/createcolletionv2'},
            {title:'Create RWA',path:'/createnftv2'}, 
        ]
    }, 
    {
        title:'About Us',
        path:'https://www.rwahubs.com'
    }
]
